export default __webpack_public_path__ + "static/support-eb4c1bf32f44e1e44794aa29a20d53eb.svg";